module.exports={
    "over_size_message":"Lähettämäsi kuva on yli 10MB. Pakkaamme tiedostosi latausta varten. Napsauta \"Vahvista\" jatkaaksesi lataamista.",
    "file_type_error":"Lataamasi tiedosto ei ole kuva! Yritä ladata uudelleen.",
    "upload_error":"Latausvirhe! (Virhekoodi: 2000) Yritä uudelleen.",
    "watermark_remove_over_size":"Lähettämäsi kuva on yli 5MB. On suositeltavaa käyttää ilmaista verkkokuvakompressoriamme. Napsauta <a class=\"jump-link\" href=\"https://www.tipard.com/fi/image-compressor-online/\">lisätietoja</a>",
    "watermark_remove_file_type_error":"Lähettämäsi tiedosto ei ole kuva, lähetä se uudelleen.",
    "watermark_remove_image_type_error":"Kuvamuotoa ei tueta. Tuemme vain JPG, JPEG, PNG ja BMP.",
    "watermark_remove_upload_error":"Tunnistusvirhe (virhekoodi: 2001), yritä uudelleen...",
    "watermark_remove_processing":"Käsitellään kuvaa...",
    "watermark_remove_not_save":"Valitsemaasi aluetta ei säilytetä. Haluatko varmasti rajata sen?",
    "watermark_remove_back_home":"Nykyistä tilaa ei tallenneta. Haluatko varmasti palata kotiin?",
    "watermark_remove_new_image":"Nykyistä tilaa ei tallenneta. Haluatko varmasti valita uuden kuvan?",
    "watermark_select":"Valitse",
    "watermark_select_area":"Valitse poistettava vesileiman alue ennen kuin napsautat Poista.",
    "watermark_beyond_4k":"Valitun kuvan resoluutio on yli 4K. Olemme pahoillamme, ettemme voi käsitellä sitä tällä hetkellä",
    "watermark_beyond_pixel_1":"Valitun kuvan resoluutio ylittää <span>%spx</span><span>&times;%spx</span>. Sitä ei voida käsitellä, valitse uudelleen.",
    "watermark_beyond_pixel_2":"Vierailijat voivat käsitellä vain <span>%s</span> kuvaa, joiden resoluutio on yli <span>%spx</span>x<span>%spx</span>. Kirjaudu sisään ja jatka käyttöä.",
    "watermark_beyond_size_1":"Valitun kuvan koko ylittää <span>%sMB</span>. Sitä ei voi käsitellä, valitse uudelleen.",
    "watermark_beyond_size_2":"Valittu kuvakoko ylittää <span>%sMB</span>, mutta vierailijat voivat käsitellä vain kuvia, jotka ovat pienempiä kuin <span>%sMB</span>. Kirjaudu sisään ja jatka käyttöä.",
    "no_user_down":"Vierailijat voivat ladata vain <span>%s</span> alkuperäislaatuista kuvaa. Kirjaudu sisään ja jatka lataamista. Voit myös säilyttää 7 päivän historian kirjautumisen jälkeen. Jatka <span>%spx</span> leveiden tai korkeiden kuvien lataamista.",
    "no_down_rights":"HD-kuvia ei voi ladata alkuperäisellä laadulla, päivitä suunnitelmasi! Voit myös jatkaa heikkolaatuisten kuvien lataamista <span>%spx</span>.",
    "error_40001":"Virhe: 40001. Ota yhteyttä",
    "error_40099":"Virhe: 40099. Ota yhteyttä",
    "down_btn":"Lataus on valmisteilla, odota hetki...",
    "noRemove_down_btn":"Et ole tehnyt mitään vesileimojen poistamiseksi. Valitse poistettava vesileima ja napsauta Poista-painiketta. Sitten voit ladata kuvasi.",
    "history_open":"Avataan muokattu kuva, odota hetki...",
    "maskRightsMonitor_info":"Etujen päivityssivu on avattu uudelle välilehdelle, ja suunnitelmasi synkronoidaan automaattisesti päivityksen jälkeen.",
    "maskLoginMonitor_info":"Aloitussivu on avattu, täytä sisäänkirjautuminen sille. Kun kirjaudut sisään tai rekisteröidyt onnistuneesti, tämä sivu synkronoidaan automaattisesti, älä sulje sitä.",
    "photo_rights_info":"Tällä hetkellä voidaan ladata <span><i class=\"num\">2</i> HD-kuvaa</span> alkuperäisellä laadulla. <a href=\"https://account.tipard.com\" target=\"_blank\">Näytä tiedot>></a>",
    "rights_original":"Sinun on päivitettävä tilisi, jotta voit ottaa käyttöön \"Käytä Image Enhancer -toimintoa vähentääksesi laadun heikkenemistä\" -asetuksen!",
    "Brush":"Harjata",
    "Lasso":"Lasso",
    "Polygonal":"Monikulmio",
    "Eraser":"Pyyhekumi",
    "Free":"Vapaa",
    "More":"Lisää:",
    "Select":"Valitse",
    "Remove":"Poista",
    "BrushSize":"Harjakoko:",
    "AspectRatio":"Kuvasuhde:",
    "Upload":"Uusi valokuva",
    "History":"Historia",
    "Login":"Kirjaudu sisään",
    "MyAccount":"Tilini",
    "Logout":"Kirjautua ulos",
    "Usinghelp":"Ohjeen käyttö >>",
    "Enhancer":"Käytä Image Enhancer -toimintoa vähentääksesi laadun heikkenemistä",
    "Download":"ladata",
    "Guide":"Opas",
    "Polygonal1":"Monikulmio",
    "Polygonal_info":"Napsauta hiiren vasenta painiketta tunnistaaksesi pisteen kerrallaan.",
    "Lasso1":"Lasso:",
    "Lasso_info":"Paina hiiren vasenta painiketta pitkään laskeaksesi vesileima-alueen.",
    "Brush1":"Harjata:",
    "Brush_info":"Valitse tarkasti painamalla hiiren vasenta painiketta pitkään.",
    "Eraser1":"Pyyhekumi:",
    "Eraser_info":"Poista tarpeettomat osat valitulta alueelta.",
    "Click":"Klikkaus",
    "the":"the",
    "click_info":"-painiketta aloittaaksesi ei-toivotun vesileiman poistamisen.",
    "PleaseUploadImages":"Lataa kuvia.",
    "CropInfo":"Kun vesileima on poistettu, voit napsauttaa Rajaa-painiketta rajataksesi kuvan ennen tallentamista tai napsauttamalla Lataa-painiketta tallentaaksesi nykyisen kuvan suoraan.",
    "Crop":"Rajaa",
    "Back":"Takaisin",
    "DownloadCropped":"Lataa rajattu",
    "Cancel":"Peruuttaa",
    "FreeWatermarkRemover":"Ilmainen vesileimanpoistoaine",
    "Processing":"Käsitellään...",
    "NewImage":"Uusi kuva",
    "Retry":"Yritä uudelleen",
    "Yes":"Joo",
    "No":"Ei",
    "FailureFeedback":"Palaute epäonnistumisesta",
    "removeTip":"Kun olet valinnut vesileima-alueen, poista vesileima napsauttamalla Poista.",
    "rightDown":"Lataa huonolaatuisia kuvia",
    "history_will":"Vanhenee jälkeen",
    "Expired":"(Vanhentunut)",
	"uploadImage":"Lisää kuva",
    "uploadImageInfo":"Tai pudota kuvatiedosto tähän poistaaksesi vesileiman!",

    "watermark_beyond_pixel_3":"The selected image exceeds <span>%s&times;%s resolution</span>, please upgrade your plan first.",
    "watermark_beyond_size_3":"The selected image exceeds <span>%sMB</span>, please upgrade your plan first.",
    "no_user_login":"New users who login can gain THREE HD original image downloading benefits.<span class=\"loginMaskbtn\">Login immediately>></span>",
    "Unlimited":"Rajoittamaton",
    "watermark_beyond_pixel_3":"Valitun kuvan resoluutio ylittää <span>%s&time;%s</span>. Päivitä suunnitelmasi ensin.",
    "watermark_beyond_size_3":"Valitun kuvan koko ylittää <span>%sMB</span>. Päivitä suunnitelmasi ensin.",
    "no_user_login":"Uudet sisäänkirjautuneet käyttäjät voivat saada KAKSIA HD-alkuperäisten kuvien latausetuja.<span class=\"loginMaskbtn\">Kirjaudu sisään välittömästi>></span>",
    "Upgrade":"Päivitä",
    "Loading":"Ladataan…",
    "SelectAll":"Valitse kaikki",
    "Open":"Avata",
    "Delete":"Poistaa",
    "Clear":"Tyhjennä virheellinen",
    "noHistory":"Ei historiaa",
    "Close":"kiinni",
    "buyUserInfo":"onnittelut! Olet päivittänyt onnistuneesti. Palaa etusivulle ja käytä tätä tuotetta.",
    "buyNoUserInfo":"Onnittelut! Olet päivittänyt onnistuneesti. Edut on sidottu sähköpostiosoitteeseen, jonka jätit päivityksen aikana. Käytä rekisteröityä tai sähköpostiosoitteeseen linkitettyä tiliä <span class=\"loginMaskbtn\">kirjautumiseen käyttääksesi etuja</span>. Jos et ole rekisteröinyt tai linkittänyt tiliä sähköpostiosoitteeseen, <span class=\"registerMaskbtn\">rekisteröi tili käyttämällä sähköpostiosoitetta</span> tai linkitä muita tilejä tähän sähköpostiin. sähköpostiosoite etuuksien käyttöä varten.",
    "GetStarted":"Aloittaa",
    "AccessTo":"Pääsy:",
    "imagesOfwatermarkremoval":"kuvia vesileiman poistosta",
    "upTo":"Aikeissa",
    "perImage":"per kuva",
    "Support":"Tuki",
    "resolution":"resoluutio",
    "PrepaidPackage":"Prepaid-paketti",
    "PayasYouGo":"Pay as You Go",
    "TaxIncl":"Sis. verot.",
    "Checkout":"Tarkista",
    "imagesDay":"kuvia/päivä",
    "imagesMonthly":"kuvia/kuukausi",
    "image":"kuva",
    "images":"kuvia",
    "imageSize":"kuvan koko",
    "buyInfo1":"Kolmannen osapuolen <span>tehostimen</span> integraatiot",
    "buyInfo2":"Muokkaushistoria on voimassa 7 päivää",
    "buyInfo3":"Ensisijainen käsittely",
    "buyInfo4":"7x24 asiakastuki",
    "buyInfo5":"Vanhentui 24 tunnin kuluttua",
    "buyInfo6":"Ei tilausta. Ei automaattista uusimista!",
    "buyInfo7":"Käytettävissä milloin tahansa ikuisesti",
    "dayPlan":"1 päivän suunnitelma",
    "Lifetime":"Elinikä",
    "note":"<span>Huomaa</span>: Huomaa, että ostettu paketti on sidottu kassalla annettuun sähköpostiosoitteeseen. Jos haluat käyttää suunnitelmaa onnistuneesti, rekisteröidy tai kirjaudu sisään samalla sähköpostiosoitteella.",
    "buy_now": "Ostaa nyt",
    
    "banner_title": "AI Photo Cleanup - kuinka monta opintopistettä haluat",
    "banner_info": "1 luotto = 1 kuva: maksat 1 luotto prosessoinnista ja tallentamisesta, joka on suurempi kuin 600 × 600 pikseliä. ",
    "monthlyPlan_title": "Kuukausisuunnitelma",
    "monthlyPlan_displayPricePerCredit": "/hyvitys",
    "monthlyPlan_plan1_credits": "hyvitykset/mo",
    "monthlyPlan_feature1": "<span> Riskiton: </span> 30 päivän rahan takaisin -takuu",
    "monthlyPlan_feature2": "<span> automaattinen: </span> hyvitykset uusitaan automaattisesti",
    "monthlyPlan_feature3": "<span> joustava: </span> aleneminen, päivitys tai peruuta milloin tahansa",
    "oneTimePurchase_title": "Kertaluonteinen osto",
    "oneTimePurchase_plan5_credits": "hyvitykset/elinikäinen",
    "oneTimePurchase_feature1": "30 päivän rahan takaisin -takuu",
    "oneTimePurchase_feature2": "Pysyvästi voimassa oston jälkeen",
    "payment_title": "Voit valita useita maksutapoja",
    "payment_image_alt": "Maksutavat",
    "faq_title": "Usein kysyttyjä kysymyksiä hyvityksistä",
    "faq_question1_title": "Mitkä ovat hyvitykset?",
    "faq_question1_info": "Palvelumme mitataan hyvitysyksikössä. ",
    "faq_question2_title": "Pitäisikö minun valita kuukausittainen tilaus tai kertaluonteinen osto?",
    "faq_question2_info": "Epäsäännölliset kuvatehtävät tai harvinainen käyttövaatimus voit valita kertaluonteisen ostoksen, josta voit ostaa oikean määrän opintopisteitä kuvavaatimusten perusteella. ",
    "faq_question3_title": "Entä jos käytän hyvityksiä?",
    "faq_question3_info": "Voit päivittää tilauksesi tai jatkaa kertaluonteisen ostosuunnitelman ostamista valokuvien käsittelytarpeiden perusteella. ",
    "faq_question4_title": "Voinko päivittää, alentaa tai peruuttaa tilaukseni?",
    "faq_question4_info": "Kyllä, voit. ",
    "whyChoose_title": "Miksi valita Tapard",
    "whyChoose_reason1_title": "Turvallinen lataus",
    "whyChoose_reason1_info": "Ohjelmat Tapardista ovat 100% puhtaita ja turvallisia",
    "whyChoose_reason2_title": "Ammattitekniikka",
    "whyChoose_reason2_info": "Ammattitaitoinen tiimi tarjoaa ammattimaisia tuotteita",
    "whyChoose_reason3_title": "24/7 asiakastuki",
    "whyChoose_reason3_info": "Potilaskonsulttipalvelut koko ajan",
    "whyChoose_reason4_title": "30 päivää rahaa takaisin",
    "whyChoose_reason4_info": "Takaa palautus käyttäjille 30 päivässä",
    "whyChoose_reason5_title": "1 000 000+ käyttäjää",
    "whyChoose_reason5_info": "Yli miljoona ihmistä käyttävät ja luottavat",
    "whyChoose_reason6_title": "160+ maata",
    "whyChoose_reason6_info": "Myydään yli 160 maassa ja alueella"
}